import { useEffect } from 'react';
import _ from 'lodash';
import {faCommentsDollar} from '@fortawesome/pro-regular-svg-icons';
import { 
    AdjustmentGridView, 
    Icon, 
    NewDisputeForm 
} from 'components';
import { 
    useAdjustmentCategory, 
    useAdjustmentType, 
    useDisputeType, 
    useNavigation 
} from 'hooks';
import { useAccountInfo, useDisputeState } from 'state';
import { AdjustmentTypeMap } from 'config';
import styles from './CreateDisputePage.module.scss';

export default function CreateDisputePage() {

    useEffect(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
    });

    // Get the selected adjustments data.
    const disputeRows = useDisputeState();
    const account = useAccountInfo(disputeRows.length ? disputeRows[0].accountId : '');
    const { navigateToDisputes } = useNavigation();

    useEffect(() => {
        if (_.isEmpty(disputeRows)) {
            navigateToDisputes();
        }
        // eslint-disable-next-line
    }, []);

    const adjustmentType = disputeRows[0].adjustmentTypeId;
    const category = useAdjustmentType(adjustmentType, AdjustmentTypeMap);
    const { isPayment } = useDisputeType(adjustmentType);
    const gridProps = useAdjustmentCategory(disputeRows, AdjustmentTypeMap, category);
    let disputeLabel :string;
    let disputeNumber: string;
    if (isPayment) {
        disputeLabel = 'Payment';
        disputeNumber = disputeRows[0]?.paymentIdRef ?? '';
    }
    else {
        disputeLabel = 'Invoice';
        disputeNumber = disputeRows[0]?.invoiceId ?? '';
    }

	return !_.isEmpty(disputeRows) ? (
        <div className={styles.page}>
            <div className={styles.pageContainer}>
                <div className={styles.pageName}>
                    <div className={styles.title}>               
                        <span>
                            <Icon icon={faCommentsDollar}/> 
                        </span>
                        <span>
                            Create Dispute 
                        </span>
                    </div>
                </div>
                <div className={styles.formContainer}>
                    <div className={styles.form}>

                        <div className={styles.formHeader}>
                            <span>
                                {disputeLabel} {disputeNumber} 
                            </span>
                            <span className={styles.separator}>|</span>
                            <span>{account.accountName} - {account.accountId}</span>             
                        </div>

                        <div className={styles.formLabel}>
                            Disputed Adjustments
                        </div>

                        <div className={styles.adjustmentsGrid}>
                            <AdjustmentGridView
                                {...gridProps}
                                isReadOnly
                                showTotal={true}
                            />
                        </div>

                        <div className={styles.formLabel}>
                            Supporting Information
                        </div>
                        
                        <NewDisputeForm
                            isPayment={isPayment}
                            adjustmentType={adjustmentType}                           
                        />
                    </div>
                </div>
            </div>
        </div>
	) : null;
}